import { Pipe, PipeTransform } from '@angular/core';
import { MultiExanteResponse } from '@zero/shared/util-models';
import { environment } from 'environments/environment';

@Pipe({
  name: 'exanteUri',
  standalone: true,
})
export class ExanteUriPipe implements PipeTransform {
  public transform(value: MultiExanteResponse, isin: string): string {
    const path = value?.responses?.find((response) => response.isin === isin)?.uri ?? '';
    return path ? environment.apihost + path : '';
  }
}
